import Avatar, {AvatarSize} from '@/components/Avatar';
import styles from './css/searchGroup.module.scss';
import {useEffect} from 'react';
import {feLogger, showAddMemberPageRecommendGroup} from '@/buried';

interface searchGroupProps{
    itemData: Array<{
        groupId: string;
        groupName: string;
        permissionName: string;
    }>;
    handleOnClick: (itemData: any)=> void;
}

export default function SearchGroup(props: searchGroupProps) {
    const {itemData, handleOnClick} = props;
    useEffect(() => {
        feLogger(showAddMemberPageRecommendGroup());
    }, []);

    return <div className={styles.searchGroupRoot}>
        {itemData.map((item) => {
            return <div key={item.groupId} className={styles.wrapper}>
                <div className={styles.groupInfo}>
                    <Avatar
                        size={'xs'}
                        defaultText={item.groupName}
                        gid={item.groupId}
                        className={styles.avatarItemTip}
                    />
                    <span className={styles.groupName}>{item.groupName}</span>
                    <div
                        className={styles.addPowerBtn}
                        onClick={() => {handleOnClick && handleOnClick(item);}}
                    >添加权限</div>
                </div>
            </div>;
        })
        }
    </div>;
}
